import { Injectable, Inject } from '@angular/core';
import {
  MODULES_CONFIGURATION_TOKEN,
  ModulesConfiguration,
  IndividualsModules,
  CommissionsModules
} from './tokens';

@Injectable({
  providedIn: 'root'
})
export class EcosureModulesService {
  individuals: IndividualsModules;
  commissions: CommissionsModules;

  constructor(
    @Inject(MODULES_CONFIGURATION_TOKEN) configuration: ModulesConfiguration
  ) {
    this.individuals = configuration.individuals;
    this.commissions = configuration.commissions;
  }
}
